import { isAuthApiError, isAuthSessionMissingError } from "@supabase/supabase-js";

// 인증 서버 장애 응답 코드(503 body.error) — api 가 내고 web 이 가른다 · 이 파일은 브라우저 번들에 들어가도 되는 순수 모듈.
export const AUTH_UNAVAILABLE_CODE = "auth_unavailable";

// 토큰 무효로 보는 상태 — 429(한도)·404·409 등 다른 4xx 는 토큰 문제가 아니다.
const REJECTED_STATUSES = new Set([400, 401, 403, 422]);

// 인증 서버가 토큰을 거절했는가 — AuthApiError 400·401·403·422·세션 없음만 거절 · 서버(getAuthUser)와 web(sessionRejected)이 같이 쓴다.
export const isRejectedAuthError = (error: unknown): boolean =>
  isAuthSessionMissingError(error) || (isAuthApiError(error) && REJECTED_STATUSES.has(error.status));
